// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as FontFaces from "../resources/theme/FontFaces.res.js";
import * as FontSizes from "../resources/theme/FontSizes.res.js";
import * as JsxRuntime from "react/jsx-runtime";

let style = Object.assign({}, {
  cursor: "inherit",
  fontFamily: FontFaces.fontFamilyFromFontName("LibreFranklin"),
  fontSize: String(FontSizes.xsmall) + `px`,
  fontWeight: "500",
  marginBottom: "7px"
}, {
  textWrap: "nowrap"
});

function Label(props) {
  let __ariaProps = props.ariaProps;
  let __color = props.color;
  let __text = props.text;
  let text = __text !== undefined ? __text : "";
  let color = __color !== undefined ? __color : "#797885";
  let ariaProps = __ariaProps !== undefined ? __ariaProps : ({});
  let colorStyle = {
    color: color
  };
  let style$1 = Object.assign({}, style, colorStyle);
  let newrecord = {...ariaProps};
  return JsxRuntime.jsx("label", (newrecord.style = style$1, newrecord.children = text, newrecord));
}

let make = React.memo(Label);

export {
  style,
  make,
}
/* style Not a pure module */
